<template>
  <div class="home-wrapper">
    <div class="main">
      <div class="enteringFlag" v-if="enteringFlag"></div>
      <div
        class="leftMenuFlag"
        v-if="leftMenuFlag"
        @click="colseLeftMenuFlag"
      ></div>
      <div class="main-left" v-if="leftMenuFlag" ref="containerContentRef">
        <div class="top">
          <img @click="goHome" src="../../../static/images/logo2.png" />
        </div>
        <!-- <div class="new">
					<div class="illName">{{healthDisease}}</div>
					<el-button :icon="Plus" :disabled="enteringFlag"  @click="createNewConversation">新建对话</el-button>
				</div> -->
        <div class="center">
          <el-collapse accordion v-model="activeNames" @change="changeRoleList">
            <el-collapse-item name="0" v-if="identityRole != 2">
              <template #title>
                <span class="left">
                  <img
                    style="
                      width: 20px;
                      float: left;
                      margin-top: 13px;
                      margin-right: 4px;
                    "
                    src="../../../static/images/zhenliao_left.png"
                  />
                  医疗
                </span>
              </template>
              <div class="user-con">
                <div class="new">
                  <el-button
                    :icon="Plus"
                    :disabled="enteringFlag"
                    @click="createNewConversation(0)"
                  >
                    新建对话</el-button
                  >
                </div>
                <ul v-if="chartTitleList.length > 0">
                  <li
                    v-for="(item, index) in chartTitleList"
                    :key="index"
                    :class="
                      item.conversationId == conversationId ? 'active' : ''
                    "
                    @click.stop="getChart(index, item)"
                    :style="{
                      cursor: enteringFlag ? 'not-allowed' : 'pointer',
                    }"
                  >
                    <el-input
                      style="color: #fff"
                      maxlength="15"
                      ref="refInputOne"
                      v-if="item.editFlag"
                      @focus="iosPut"
                      @blur="completeTitle(index, item)"
                      v-model="item.title"
                    >
                    </el-input>
                    <span v-else class="txt">{{ item.title }}</span>
                    <span class="icon" v-if="item.hoverFlag">
                      <Edit
                        @click.stop="editTitle(index, item)"
                        style="
                          width: 1em;
                          height: 1em;
                          margin-right: 4px;
                          margin-top: 10px;
                        "
                      />
                      <Delete
                        @click.stop="delTitle(item.conversationId, item)"
                        style="width: 1em; height: 1em; margin-top: 10px"
                      />
                    </span>
                  </li>
                </ul>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="gptLogin != 2"
              style="display: none"
              name="1"
            >
              <template #title>
                <span class="left">
                  <img
                    style="
                      width: 20px;
                      float: left;
                      margin-top: 13px;
                      margin-right: 4px;
                    "
                    src="../../../static/images/duolun.png"
                  />
                  知病多轮
                </span>
              </template>
              <div class="user-con">
                <div class="new">
                  <el-button
                    :icon="Plus"
                    :disabled="enteringFlag"
                    @click="createNewConversation(1)"
                  >
                    新建对话</el-button
                  >
                </div>
                <ul v-if="chartTitleList.length > 0">
                  <li
                    v-for="(item, index) in chartTitleList"
                    :key="index"
                    :class="
                      item.conversationId == conversationId ? 'active' : ''
                    "
                    @mouseenter="enter(index)"
                    @mouseleave="leave(index)"
                    @click.stop="getChart(index, item)"
                    :style="{
                      cursor: enteringFlag ? 'not-allowed' : 'pointer',
                    }"
                  >
                    <el-input
                      style="color: #fff"
                      maxlength="15"
                      ref="refInputTwo"
                      v-if="item.editFlag"
                      @blur="completeTitle(index, item)"
                      v-model="item.title"
                    >
                    </el-input>
                    <span v-else class="txt">{{ item.title }}</span>
                    <span class="icon" v-if="item.hoverFlag">
                      <Edit
                        @click.stop="editTitle(index, item)"
                        style="
                          width: 1em;
                          height: 1em;
                          margin-right: 4px;
                          margin-top: 10px;
                        "
                      />
                      <Delete
                        @click.stop="delTitle(item.conversationId, item)"
                        style="width: 1em; height: 1em; margin-top: 10px"
                      />
                    </span>
                  </li>
                </ul>
              </div>
            </el-collapse-item>
            <el-collapse-item name="4">
              <template #title>
                <span class="left">
                  <img
                    style="
                      width: 20px;
                      float: left;
                      margin-top: 13px;
                      margin-right: 4px;
                    "
                    src="../../../static/images/yangsheng_left.png"
                  />
                  养生
                </span>
              </template>
              <div class="user-con">
                <div class="new">
                  <el-button
                    :icon="Plus"
                    :disabled="enteringFlag"
                    @click="createNewConversation(4)"
                  >
                    新建对话</el-button
                  >
                </div>
                <ul v-if="chartTitleList.length > 0">
                  <li
                    v-for="(item, index) in chartTitleList"
                    :key="index"
                    :class="
                      item.conversationId == conversationId ? 'active' : ''
                    "
                    @mouseenter="enter(index)"
                    @mouseleave="leave(index)"
                    @click.stop="getChart(index, item)"
                    :style="{
                      cursor: enteringFlag ? 'not-allowed' : 'pointer',
                    }"
                  >
                    <el-input
                      style="color: #fff"
                      maxlength="15"
                      ref="refInputThree"
                      v-if="item.editFlag"
                      @blur="completeTitle(index, item)"
                      v-model="item.title"
                    >
                    </el-input>
                    <span v-else class="txt">{{ item.title }}</span>
                    <span class="icon" v-if="item.hoverFlag">
                      <Edit
                        @click.stop="editTitle(index, item)"
                        style="
                          width: 1em;
                          height: 1em;
                          margin-right: 4px;
                          margin-top: 10px;
                        "
                      />
                      <Delete
                        @click.stop="delTitle(item.conversationId, item)"
                        style="width: 1em; height: 1em; margin-top: 10px"
                      />
                    </span>
                  </li>
                </ul>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="bottom">
          <ul>
            <li
              v-for="(item, index) in userList"
              :key="index"
              @click="goClick(index)"
            >
              <img v-if="index != 2" :src="item.img" />
              <span class="imgSpan" v-if="index == 2">
                <img
                  :src="
                    userInfo.avatar ? globalImgPath + userInfo.avatar : item.img
                  "
                />
              </span>
              <p class="userInfo">
                <span v-if="userInfo && index == 2"
                  >欢迎，{{ userInfo.name }}</span
                >
                <span>
                  {{ item.name }}
                </span>
              </p>
            </li>
            <li class="quitLogin" @click="quitLogin">
              <SwitchButton class="quit"></SwitchButton>

              <span>退出登录</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 右侧主内容区 -->
      <div class="main-right">
        <router-view
          v-slot="{ Component, route }"
          :key="route.fullPath"
          @getConversateList="getConversateList"
          @getEnteringFlag="getEnteringFlag"
          @getUserInfo="getUserInfo"
          @getRole="getRole"
          @openLeftMenu="openLeftMenu"
          :conversationId="conversationId"
          :conversationDetail="conversationDetail"
        >
          <component ref="childGpt" :is="Component" :key="route.fullPath" />
        </router-view>
        <!-- <span class="out" @click="quitLogin">退出登陆</span> -->
      </div>
    </div>
    <el-dialog
      title="请预先选择疾病分类："
      v-model="multipleDialogueFlag"
      width="380px"
      align-center
    >
      <div class="login-content single">
        <ul>
          <li
            v-for="(item, index) in multipleIllList"
            :key="index"
            @click="goMultipleChart(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      title="请预先选择疾病分类："
      v-model="singleDialogueFlag"
      width="380px"
      align-center
    >
      <div class="login-content">
        <ul>
          <li
            v-for="(item, index) in singleIllList"
            :key="index"
            @click="goSingleChart(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Plus, SwitchButton } from "@element-plus/icons-vue";
import {
  ref,
  nextTick,
  reactive,
  toRefs,
  defineComponent,
  getCurrentInstance,
  onMounted,
} from "vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { showConfirmDialog } from "vant";
//import { useStore } from 'vuex' // 引入useStore 方法
export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    //const store = useStore()  // 该方法用于返回store 实例
    const uniHttp = getCurrentInstance().appContext.config.globalProperties;
    const globalImgPath = uniHttp.globalImgPath;
    const refInputOne = ref(null);
    const refInputTwo = ref(null);
    const refInputThree = ref(null);
    const childGpt = ref(null);
    const containerContentRef = ref(null);
    const data = reactive({
      chartTitleList: [],
      currentPage: 0, //当前页面
      chartIndex: -1,
      userInfo: {},
      identityRole: 1,
      conversationDetail: {},
      conversationId: 0,
      enteringFlag: false,
      gptLogin: 0,
      userList: [
        {
          img: require("../../../static/images/qingkong.png"),
          name: "清空所有对话主题",
        },
        /* {
						img: require("../../../static/images/caozuozhinan.png"),
						name: '操作指南'
					}, */
        {
          img: require("../../../static/images/guanyuwomen.png"),
          name: "关于我们",
        },
        {
          img: require("../../../static/images/touxiang.png"),
          name: "点击进入个人中心",
        },
      ],
      touxiang: require("../../../static/images/touxiang.png"),
      userListCurrentIndex: -1,
      role: 0,
      healthDisease: "",
      multipleDialogueFlag: false,
      singleDialogueFlag: false,
      singleIllList: [
        {
          name: "冠心病心绞痛",
          id: 0,
        },
        {
          name: "痛经",
          id: 1,
        },
      ],
      multipleIllList: [
        {
          name: "胃脘痛",
          id: 0,
        },
      ],
      activeNames: ["2"],
      leftMenuFlag: false,
      originalHeight: 0,
    });

    //获取用户信息
    const getUserInfo = () => {
      data.role = window.localStorage.getItem("role");
      data.gptLogin = window.localStorage.getItem("gptLogin");
      uniHttp
        .$applicationJson("business/user/info")
        .then((res) => {
          if (res.data.code == 0) {
            data.userInfo = res.data.data; //获取用户信息更新头像和昵称
            data.identityRole = data.userInfo.role;
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
      getConversationList(data.role);
    };

    //子组件传过来显示左侧菜单的值
    const openLeftMenu = (val) => {
      data.leftMenuFlag = val;
    };
    const colseLeftMenuFlag = () => {
      data.leftMenuFlag = false;
      nextTick(() => {
        childGpt.value.colseLeftMenu();
      });
    };
    //新建聊天
    const createNewConversation = (role) => {
      data.role = role;
      /* if(role == 0){ //知病单轮
					data.singleDialogueFlag = true
				}
				if(role == 1){ //知病多轮
					data.multipleDialogueFlag = true
				}
				if(role == 2){ //养生多轮
					conversationAdd(role,'','');
				} */
      colseLeftMenuFlag();
      getList(role);
      //conversationAdd(role, '', '');
    };

    //获取标题列表
    const getList = (role) => {
      uniHttp
        .$applicationJson("business/conversation/paging", {
          current: 0,
          pageSize: 1000,
          params: {
            role: role,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            const chartTitleList = res.data.data.records.reverse();
            if (chartTitleList.length == 0) {
              conversationAdd(role, "", "");
            } else {
              if (
                chartTitleList[0].title == "" ||
                chartTitleList[0].title == null
              ) {
                let conversationId = chartTitleList[0].conversationId;
                router.replace({
                  path: "/GptChart/GptChart",
                  query: {
                    conversationId: conversationId,
                    question: "",
                    illName: "",
                    role: data.role,
                  },
                });
              } else {
                conversationAdd(role, "", "");
              }
            }
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //新增标题
    const conversationAdd = (role, type, illName) => {
      uniHttp
        .$applicationJson("business/conversation/add", {
          role: data.role,
          illName: illName,
        })
        .then((res) => {
          if (res.data.code == 0) {
            data.conversationDetail = res.data.data;
            data.conversationId = res.data.data.conversationId;
            getConversationList(role, type, res.data.data);
            router.replace({
              path: "/GptChart/GptChart",
              query: {
                conversationId: data.conversationId,
                question: "",
                del: data.role,
                illName: "",
                role: data.role,
              },
            });
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //编辑标题
    const conversationEdit = (item) => {
      uniHttp
        .$applicationJson("business/conversation/edit", {
          conversationId: item.conversationId,
          title: item.title,
          illName: item.illName,
        })
        .then((res) => {
          if (res.data.code == 0) {
            data.conversationDetail.title = item.title;
            getConversationList(item.role);
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //获取标题列表
    const getConversationList = (role, type) => {
      uniHttp
        .$applicationJson("business/conversation/paging", {
          current: data.currentPage,
          pageSize: 1000,
          params: {
            role: role,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            data.chartTitleList = res.data.data.records.reverse();
            for (let i = 0; i < data.chartTitleList.length; i++) {
              data.chartTitleList[i].hoverFlag = true;
            }
            if (type == "del") {
              data.chartIndex = data.chartTitleList.length - 1;
              if (res.data.data.records.length == 0) {
                router.push({
                  path: "/GptChartIndex/GptChartIndex",
                  query: {
                    conversationId: 0,
                  },
                });
              } else {
                router.replace({
                  path: "/GptChart/GptChart",
                  query: {
                    conversationId: data.chartTitleList[0].conversationId,
                    question: "",
                    del: data.role,
                    illName: data.chartTitleList[0].illName,
                    role: data.role,
                  },
                });
              }
            }
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //编辑标题
    const editTitle = (index, item) => {
      console.log(item);
      data.chartTitleList[index].editFlag = true;
      if (item.role == 0) {
        nextTick(() => {
          refInputOne.value[0].focus();
        });
      }
      if (item.role == 1) {
        nextTick(() => {
          refInputTwo.value[0].focus();
        });
      }
      if (item.role == 4) {
        nextTick(() => {
          refInputThree.value[0].focus();
        });
      }
    };

    //标题输入完成后
    const completeTitle = (index, item) => {
      data.chartTitleList[index].editFlag = false;
      conversationEdit(item);
      const userAgent =
        typeof window === "object" ? window.navigator.userAgent : "";
      if (!/android/i.test(userAgent)) {
        nextTick(() => {
          containerContentRef.value.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        });
      }
    };

    const iosPut = () => {
      const userAgent =
        typeof window === "object" ? window.navigator.userAgent : "";
      if (!/android/i.test(userAgent)) {
        nextTick(() => {
          containerContentRef.value.scrollTo({
            top: containerContentRef.value.scrollHeight,
            behavior: "smooth",
          });
        });
      }
    };
    //删除标题
    const delTitle = (conversationId, item) => {
      showConfirmDialog({
        title: "提示",
        message: "确认要删除此对话？",
      })
        .then(() => {
          conversationDel(conversationId, item);
        })
        .catch(() => {});
      /* ElMessageBox.confirm('确认要删除此对话？', {
					cancelButtonText: '取消',
					confirmButtonText: '确认',
				}).then(() => {
					conversationDel(conversationId, item)
				}).catch(() => {

				}) */
    };

    //删除标题
    const conversationDel = (conversationId, item) => {
      let ids = [];
      ids.push(conversationId);
      uniHttp
        .$applicationJson("business/conversation/delete", {
          ids: ids,
        })
        .then((res) => {
          if (res.data.code == 0) {
            colseLeftMenuFlag();
            getConversationList(item.role, "del", item);
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //删除所有
    const conversationDelAll = () => {
      uniHttp
        .$applicationJson("business/conversation/delete/all", {
          role: "",
        })
        .then((res) => {
          if (res.data.code == 0) {
            getConversationList();
            colseLeftMenuFlag();
            data.conversationDetail = {};
            createNewConversation(data.role);
            /*
            if (data.gptLogin == 2) {
              goGptLogin();
            } else {
              router.push({
                path: "/GptChartIndex/GptChartIndex",
                query: {
                  conversationId: 0,
                },
              });
            }
            */
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //点击左侧新建聊天菜单
    const getChart = (index, item) => {
      if (data.enteringFlag) {
        return false;
      }
      data.chartIndex = index;
      data.conversationDetail = item;
      data.conversationId = item.conversationId;
      colseLeftMenuFlag();
      if (data.role == 4) {
        whetherChatLog(); //养生多轮判断是否有聊天记录
      }
      if (data.role == 0 || data.role == 1) {
        //知病直接进入聊天界面
        router.replace({
          path: "/GptChart/GptChart",
          query: {
            conversationId: data.conversationId,
            question: "",
            illName: item.illName,
            role: data.role,
          },
        });
      }
    };

    //判断当前话题是否有聊天记录
    const whetherChatLog = () => {
      router.replace({
        path: "/GptChart/GptChart",
        query: {
          conversationId: data.conversationId,
          question: "",
          illName: data.illName,
          role: data.role,
        },
      });
    };

    //点击左侧新建聊天菜单
    const enter = (index) => {
      data.chartTitleList[index].hoverFlag = true;
    };

    //点击左侧新建聊天菜单
    const leave = (index) => {
      data.chartTitleList[index].hoverFlag = false;
    };

    //底部路由切换
    const goClick = (index) => {
      data.userListCurrentIndex = index;
      if (index == 0) {
        //清空所有对话
        deleteAll();
      }
      /* if (index == 1) { //操作指南
					goInstruction();
				} */
      if (index == 1) {
        //关于我们
        goAboutUs();
      }
      if (index == 2) {
        //个人中心
        goPersonalCenter();
      }
    };

    //删除所有
    const deleteAll = () => {
      if (data.enteringFlag) {
        return false;
      }

      showConfirmDialog({
        title: "提示",
        message: "确认要清空所有对话主题？",
      })
        .then(() => {
          conversationDelAll();
        })
        .catch(() => {});

      /* ElMessageBox.confirm('确认要清空所有对话主题？', {
					cancelButtonText: '取消',
					confirmButtonText: '确认',
				}).then(() => {
					conversationDelAll()
				}).catch(() => {

				}) */
    };

    //操作指南
    const goInstruction = () => {
      if (data.enteringFlag) {
        return false;
      }
      router.push({
        path: "/OperateGuide/OperateGuide",
      });
    };

    //关于我们
    const goAboutUs = () => {
      if (data.enteringFlag) {
        return false;
      }
      colseLeftMenuFlag();
      router.push({
        path: "/AboutUs/AboutUs",
      });
    };

    //个人中心
    const goPersonalCenter = () => {
      if (data.enteringFlag) {
        return false;
      }
      colseLeftMenuFlag();
      router.push({
        path: "/PersonalCenter/PersonalCenter",
      });
    };

    //知病多伦
    const goMultipleChart = (item) => {
      knowledgellnessAdd(item.name, item.name, item.name);
      data.multipleDialogueFlag = false;
    };

    //知病单轮
    const goSingleChart = (item) => {
      knowledgellnessAdd(item.name, "", item.name);
      data.singleDialogueFlag = false;
    };

    //知病新增
    const knowledgellnessAdd = (name, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/add", {
          role: data.role,
          illName: illName,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let conversationId = res.data.data.conversationId;
            knowledgellnessEdit(name, conversationId, question, illName);
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //知病编辑
    const knowledgellnessEdit = (name, conversationId, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/edit", {
          conversationId: conversationId,
          title: name,
        })
        .then((res) => {
          if (res.data.code == 0) {
            router.replace({
              path: "/GptChart/GptChart",
              query: {
                conversationId: conversationId,
                question: "",
                illName: illName,
                role: data.role,
              },
            });
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //获取conversationId
    const getConversateList = (conversationId) => {
      data.conversationId = conversationId;
    };

    //获取是否中止状态
    const getEnteringFlag = (EnteringFlag) => {
      data.enteringFlag = EnteringFlag;
    };

    //获取角色
    const getRole = (role) => {
      data.role = role;
      data.activeNames = [role];
      getConversationList(role);
    };

    //切换角色列表
    const changeRoleList = (role) => {
      data.role = role;
      window.localStorage.setItem("role", role);
      if (role) {
        getConversationList(role);
      }
    };

    //返回首页
    const goHome = () => {
      router.push({
        path: "/GptChartIndex/GptChartIndex",
        query: {
          conversationId: 0,
        },
      });
    };
    const quitLogin = () => {
      router.push({
        path: "/GptIndex/GptIndex",
      });
      window.localStorage.removeItem("loginFlag");
      window.localStorage.removeItem("status");
      window.localStorage.removeItem("GptMToken");
    };

    /*
    //公测版清空所有对话主题  删除所有 重新新增一个
    const goGptLogin = () => {
      conversationGptAdd("", "", "");
    };

    const conversationGptAdd = (name, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/add", {
          role: data.role,
          illName: illName,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let conversationId = res.data.data.conversationId;
            conversationGptEdit(name, conversationId, question, illName);
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    const conversationGptEdit = (name, conversationId, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/edit", {
          conversationId: conversationId,
          title: name,
        })
        .then((res) => {
          if (res.data.code == 0) {
            window.localStorage.setItem("preQuestion", "");
            router.replace({
              path: "/GptChart/GptChart",
              query: {
                conversationId: conversationId,
                question: question,
                illName: illName,
                role: data.role,
              },
            });
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };
    */

    // Android系统
    const onResize = () => {
      //键盘弹起与隐藏都会引起窗口的高度发生变化
      const resizeHeight = window.innerHeight;
      if (data.originalHeight - resizeHeight < 50) {
        nextTick(() => {
          refInputOne.value[0].blur();
        });
      }
    };

    onMounted(() => {
      data.originalHeight = window.innerHeight;
      getUserInfo();
      //安卓
      const userAgent =
        typeof window === "object" ? window.navigator.userAgent : "";
      if (/android/i.test(userAgent)) {
        window.addEventListener("resize", onResize);
      }
    });

    return {
      childGpt,
      containerContentRef,
      Plus,
      SwitchButton,
      uniHttp,
      globalImgPath,
      refInputOne,
      refInputTwo,
      refInputThree,
      route,
      ...toRefs(data),
      getUserInfo,
      getConversationList,
      createNewConversation,
      conversationAdd,
      conversationEdit,
      editTitle,
      completeTitle,
      delTitle,
      deleteAll,
      conversationDel,
      getChart,
      enter,
      leave,
      goInstruction,
      goAboutUs,
      goPersonalCenter,
      getConversateList,
      getEnteringFlag,
      goClick,
      getRole,
      goMultipleChart,
      goSingleChart,
      knowledgellnessAdd,
      knowledgellnessEdit,
      changeRoleList,
      goHome,
      quitLogin,
      openLeftMenu,
      colseLeftMenuFlag,
      onResize,
      iosPut,
    };
  },
});
</script>
<style lang="less" scoped>
.home-wrapper {
  width: 100%;
  height: 100%;
  background: #fff !important;
  //display: flex;
  left: 0;
  top: 0;
  overflow-x: hidden;
  position: absolute;
  overflow-y: auto;
  /* 主内容区 */
  .main {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;

    .enteringFlag {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      z-index: 1;
      cursor: not-allowed;
      width: 80%;
    }
    .leftMenuFlag {
      position: absolute;
      left: 80%;
      top: 0;
      height: 100%;
      z-index: 1;
      width: calc(100%);
      background-color: var(--el-overlay-color-lighter);
    }
    .main-left {
      flex: 0 0 80%;
      background: #fff;
      position: relative;
      background: #1b2129;
      height: 100%;
      z-index: 2;
      overflow-y: auto;

      .top {
        height: 1.2rem;
        width: 100%;

        img {
          width: 2.4rem;
          margin-top: 0.3rem;
          float: left;
          margin-left: 0.2rem;
          cursor: pointer;
        }
      }

      .new {
        width: 92%;
        margin-left: 4%;
        height: 1rem;

        .illName {
          width: 100%;
          width: calc(100% - 2px);
          height: 36px;
          line-height: 36px;
          border-radius: 3px;
          color: #e7e8e8;
          float: left;
          text-align: center;
          background: #4564d4;
        }

        .el-button {
          margin-top: 0.1rem;
          width: 100%;
          background-color: transparent !important;
          border: 1px solid #2b333e !important;
          color: #fff;
          font-size: 0.3rem;
          height: 0.8rem;
          line-height: 0.8rem;
        }
      }

      .center {
        width: 100%;
        height: calc(100% - 5.4rem);
        overflow-y: scroll;
        overflow-x: hidden;
        position: relative;
        -webkit-overflow-scrolling: touch;
        overflow-scrolling: touch;
        /deep/ .el-collapse {
          border-top: 0px;
          background-color: transparent !important;
          border-bottom: 0px;

          .el-collapse-item {
            background-color: transparent !important;
            border-bottom: 0px solid #eee;

            .el-collapse-item__header,
            .el-collapse-item__wrap {
              background-color: transparent !important;
              color: #fff;
              border-bottom: 1px solid #1b2129;
            }

            .el-collapse-item__header.is-active {
              background: #4564d4 !important;
            }

            .el-collapse-item__header {
              background: #2b333e !important;

              .left {
                width: 92%;
                padding-left: 4%;
              }
            }

            .el-collapse-item__content {
              width: 92%;
              padding-left: 4%;
            }

            .el-collapse-item__content {
              color: #fff;
            }
          }
          .gptLogin {
            .el-collapse-item__header.is-active {
              background: #2b333e !important;
              display: none;
            }
          }
        }

        ul {
          width: 100%;

          li {
            width: 100%;
            background-color: transparent !important;
            border: 1px solid #2b333e !important;
            width: calc(100% - 2px);
            height: 0.8rem;
            line-height: 0.8rem;
            border-radius: 3px;
            color: #e7e8e8;
            float: left;
            margin-bottom: 10px;
            cursor: pointer;

            .el-icon {
              float: left;
            }

            span {
              display: inline-block;
              float: left;
            }

            .chartIcon {
              font-size: 0.32rem;
              width: 20px;
              padding-left: 10px;
              padding-right: 2px;
              cursor: pointer;
            }

            .icon {
              font-size: 0.4rem;
              width: 0.9rem;
              cursor: pointer;
              right: 10px;
              color: #fff;
              float: left;
              float: right;
            }

            .txt {
              display: inline-block;
              width: calc(100% - 1.2rem);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-left: 10px;
              float: left;
              font-size: 0.32rem;
            }

            .el-input {
              width: 140px;
              background: transparent !important;
              border: 1px solid transparent !important;
              font-size: 0.32rem;
              /deep/ .el-input__wrapper {
                background: transparent !important;
                color: #fff;
                box-shadow: none;
              }

              /deep/ .el-input__inner {
                color: #fff;
              }
            }

            &.active {
              border: 1px solid #4564d4 !important;
              background: #2b333e !important;
            }

            &:hover {
              border: 1px solid #2b333e !important;
              background: #2b333e !important;
            }
          }
        }
      }

      .bottom {
        position: absolute;
        bottom: 0;
        height: 4rem;
        width: 100%;
        border-top: 1px solid #2b333e;
        padding: 0.15rem 0 0 0;

        ul {
          width: 100%;

          li {
            img {
              float: left;
              width: 0.5rem;
              margin-top: 0.15rem;
              margin-right: 3px;
            }

            width: calc(100% - 20px);
            text-align: left;
            padding-left: 0.2rem;
            color: #e7e8e8;
            line-height: 0.8rem;
            height: 0.8rem;
            cursor: pointer;
            font-size: 0.32rem;

            &:hover {
              background: #2b333e !important;
            }

            &.active {
              background: #2b333e !important;
            }

            &:nth-child(3) {
              border-top: 1px solid #2b333e;
              margin-top: 10px;
              padding: 10px 0 10px 0.26rem;
              font-size: 0.32rem;
              img {
                margin-right: 5px;
                float: left;
              }

              .imgSpan {
                float: left;
                width: 20px;
                margin-right: 5px;

                img {
                  width: 20px;
                  border-radius: 20px;
                }
              }

              p {
                float: left;
                width: calc(100% - 40px);

                span {
                  display: block;
                  line-height: 0.4rem;
                  font-size: 0.32rem;
                  color: #fff;
                  overflow: hidden; //超出的文本隐藏
                  text-overflow: ellipsis; //溢出用省略号显示
                  white-space: nowrap; // 默认不换行；
                  width: 100%;
                  &:nth-child(2) {
                    font-size: 0.26rem;
                    color: rgba(215, 215, 215, 0.55);
                  }
                }
              }
            }
          }
          .quitLogin {
            border-top: 1px solid #2b333e;
            padding-left: 0.26rem;
            height: 1rem;
            line-height: 1rem;
            .quit {
              width: 0.4rem;
              margin-top: 0.3rem;
              float: left;
              margin-right: 8px;
            }
          }

          .goPersonalCenter {
            border-top: 1px solid rgba(255, 255, 255, 0.2);
            margin-top: 10px;
            padding: 10px 0 10px 20px;

            img {
              margin-right: 5px;
              float: left;
            }

            p {
              float: left;
              width: calc(100% - 40px);

              span {
                display: block;
                line-height: 20px;
                font-size: 0.28rem;
                color: #fff;

                &:nth-child(2) {
                  font-size: 0.24rem;
                  color: rgba(215, 215, 215, 0.55);
                }
              }
            }
          }
        }
      }
    }
    .leftMenu {
      animation-name: fadeOutLeft; /*fadeInLeft为要使用的动画效果名，在这里不需要加animate前缀*/
      animation-duration: 1s; /*这里设定完成该动画的时间*/
    }
    .main-right {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      .out {
        float: right;
        cursor: pointer;
        border: 1px solid #eee;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        padding: 0 20px;
        position: absolute;
        right: 30px;
        top: 10px;
      }
    }
  }

  .login-content {
    height: 40px;

    ul {
      width: 230px;
      margin: 0 auto;

      li {
        float: left;
        line-height: 30px;
        width: 100px;
        border: 1px solid #409eff;
        margin-right: 10px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        background: #409eff;
        color: #fff;
      }
    }
  }

  .single {
    ul {
      width: 122px;
      margin: 0 auto;
    }
  }
  /deep/ .el-message-box__message {
    font-size: 0.28rem;
  }
}
</style>
